import { ExtractPropTypes, PropType } from 'vue'

export const regionSelectProps = {
  // 双向数据绑定的该组件的值
  value: {
    type: Array as PropType<string[]>,
    default: undefined,
  },
}

export type RegionSelectProps = ExtractPropTypes<typeof regionSelectProps>


